import { createSignal, onMount, Show } from 'solid-js'
import { Viewport } from './canvas/Viewport.tsx'
import { installPasteAndDrop } from './paste.ts'
import { installAutosave, openInitialProject } from './project.ts'
import { installShortcuts } from './shortcuts.ts'
import { LayersPanel } from './ui/LayersPanel.tsx'
import { ProjectPicker } from './ui/ProjectPicker.tsx'
import { StatusBar } from './ui/StatusBar.tsx'
import { Toolbar } from './ui/Toolbar.tsx'
import { TopBar } from './ui/TopBar.tsx'

export function App() {
  const [showProjects, setShowProjects] = createSignal(false)
  const [startupError, setStartupError] = createSignal<string | null>(null)

  installShortcuts()
  installPasteAndDrop()
  installAutosave()

  onMount(() => {
    void openInitialProject().catch((err) => {
      console.error('Could not open a project', err)
      setStartupError(String(err))
    })
  })

  return (
    <div class="app">
      <TopBar onOpenProjects={() => setShowProjects(true)} />

      <Show when={startupError()}>
        {(message) => <div class="banner error">{message()}</div>}
      </Show>

      <div class="stage">
        <Viewport />
        <Toolbar />
        <aside class="sidebar">
          <LayersPanel />
        </aside>
      </div>

      <StatusBar />

      <Show when={showProjects()}>
        <ProjectPicker onClose={() => setShowProjects(false)} />
      </Show>
    </div>
  )
}
